import api from '@/apis/di/dvcStateTreasuryAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('dVCStateTreasury', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_dvc_state_bank',
    field: {
      key: 'state_bank_id',
      code: 'state_bank_code',
      name: 'state_bank_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
